"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var FormGroup_1 = __importDefault(require("@material-ui/core/FormGroup"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/styles");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var styles_2 = __importDefault(require("./styles"));
var GenericFormCheckbox = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors, overrideClasses = _a.overrideClasses;
    var useStyles = styles_1.makeStyles(styles_2.default(overrideClasses));
    var classes = useStyles({ fontSize: item.fontSize });
    var showError = function () {
        if (lodash_1.get(errors, item.error, null))
            return (react_1.default.createElement(FormHelperText_1.default, null, lodash_1.get(errors, item.error, null)));
        if (lodash_1.get(errors, item.stateKey, null))
            return (react_1.default.createElement(FormHelperText_1.default, null, lodash_1.get(errors, item.stateKey, null)));
        return null;
    };
    return (react_1.default.createElement(FormControl_1.default, { fullWidth: true, error: !!lodash_1.get(errors, item.stateKey, null) ||
            lodash_1.get(errors, item.error, null) },
        react_1.default.createElement(FormGroup_1.default, { row: true },
            react_1.default.createElement(FormControlLabel_1.default, { key: item.stateKey, disabled: item.disabled, className: classes.checkboxFormControlLabel, control: react_1.default.createElement(Checkbox_1.default, { id: item.idHtml || item.stateKey, checked: fields
                        ? lodash_1.get(fields, item.stateKey, null)
                        : lodash_1.get(values, item.stateKey, null), className: classes.checkbox, onChange: function (e) {
                        if (setFieldValue)
                            setFieldValue(item.stateKey, e.target.checked);
                        if (changeField)
                            changeField({
                                key: item.stateKey,
                                value: e.target.checked,
                            });
                    }, color: item.color, value: fields ? fields[item.stateKey] : values[item.stateKey] }), label: react_1.default.createElement(Typography_1.default, { className: classes.checkboxLabel }, item.label) })),
        showError()));
};
exports.default = GenericFormCheckbox;
//# sourceMappingURL=GenericFormCheckbox.js.map